import React from 'react'
import { Alert, Button, Container, Col, Row } from 'react-bootstrap'
import encounterStatusEnum from '../../utils/encounterStatusEnum'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

const SessionAlert = ({ sessionStatus, patient, encounter, onResetPatient, onStartOver, onContinue, onViewSession }) => {
  return (
    <Container className="pt-5">
      <Alert variant="info">
        <Alert.Heading>
          {sessionStatus.previousSession && 'Previous Session Found'} 
          {sessionStatus.value === encounterStatusEnum.FINISHED.value && 'Finished Session Found'}
        </Alert.Heading>
        <p>
            A Lupus Advisor session for {patient.firstName} {patient.middleName || ''} {patient.lastName} was {sessionStatus.previousSession ? 'started' : 'completed'} on {format(new Date(encounter.status.createdAt), 'MM/dd/yyyy')} at {format(new Date(encounter.status.createdAt), 'HH:mm:ss')}. {sessionStatus.draftSession ? 'Continue?' : 'How would you like to proceed?'}
        </p>
        <hr />
        <Row>
          <Col xs={5}>
            <Button variant='outline-info' onClick={() => onResetPatient()}>
                Reset Patient Data
            </Button>
          </Col>
          <Col xs={4} className='text-right'>
            {
              sessionStatus.previousSession && (
                <Button variant='outline-info' onClick={() => onStartOver()}>
                    Fetch New Data and Start Over
                </Button>
              )
            }
          </Col>
          <Col xs={3} className='text-right'>
            <Button 
              variant='outline-info' 
              onClick={() => sessionStatus.previousSession ? onContinue() : onViewSession()}>
              {
                sessionStatus.previousSession ? 'Continue' : 'View Session Summary'
              }
            </Button>
          </Col>
        </Row>
      </Alert>
    </Container>
  )
}

SessionAlert.propTypes = {
  sessionStatus: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired,
  encounter: PropTypes.object.isRequired,
  onResetPatient: PropTypes.func.isRequired,
  onStartOver: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onViewSession: PropTypes.func.isRequired
}

export default SessionAlert